// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-red: #ed3338;
  --light-red: rgba(237, 51, 56, 0.1);

  --primary-blue: #2355b6;
  --light-blue: rgba(35, 85, 182, 0.1);

  --orange: #fc7d13;
  --light-orange: rgba(252, 125, 19, 0.1);

  --green: #4bae50;
  --light-green: rgba(75, 174, 80, 0.1);

  --bg-light: #f4fafd;
  --text-dark: #2c2c2c;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/colors.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mCAAmC;;EAEnC,uBAAuB;EACvB,oCAAoC;;EAEpC,iBAAiB;EACjB,uCAAuC;;EAEvC,gBAAgB;EAChB,qCAAqC;;EAErC,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[":root {\r\n  --primary-red: #ed3338;\r\n  --light-red: rgba(237, 51, 56, 0.1);\r\n\r\n  --primary-blue: #2355b6;\r\n  --light-blue: rgba(35, 85, 182, 0.1);\r\n\r\n  --orange: #fc7d13;\r\n  --light-orange: rgba(252, 125, 19, 0.1);\r\n\r\n  --green: #4bae50;\r\n  --light-green: rgba(75, 174, 80, 0.1);\r\n\r\n  --bg-light: #f4fafd;\r\n  --text-dark: #2c2c2c;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
